export interface SnoozePreset {
    id: "one-hour" | "later-today" | "tomorrow-morning" | "friday-afternoon" | "next-monday" | "one-month"
    label: string
    at: Date
}

const HOUR_MS = 60 * 60 * 1000

export function snoozePresets(now: Date): SnoozePreset[] {
    const presets: SnoozePreset[] = [
        {
            id: "one-hour",
            label: "In 1 hour",
            at: new Date(now.getTime() + HOUR_MS),
        },
    ]
    const laterToday = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 17, 0, 0, 0)
    if (laterToday.getTime() >= now.getTime() + HOUR_MS) {
        presets.push({ id: "later-today", label: "Later today", at: laterToday })
    }

    presets.push({
        id: "tomorrow-morning",
        label: "Tomorrow morning",
        at: new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 9, 0, 0, 0),
    })

    const daysUntilFriday = (5 - now.getDay() + 7) % 7
    let fridayAfternoon = new Date(now.getFullYear(), now.getMonth(), now.getDate() + daysUntilFriday, 16, 0, 0, 0)
    if (fridayAfternoon.getTime() < now.getTime() + HOUR_MS) {
        fridayAfternoon = new Date(now.getFullYear(), now.getMonth(), now.getDate() + daysUntilFriday + 7, 16, 0, 0, 0)
    }
    presets.push({ id: "friday-afternoon", label: "Friday afternoon", at: fridayAfternoon })

    const daysUntilMonday = (8 - now.getDay()) % 7 || 7
    presets.push({
        id: "next-monday",
        label: "Next Monday",
        at: new Date(now.getFullYear(), now.getMonth(), now.getDate() + daysUntilMonday, 9, 0, 0, 0),
    })

    const targetMonth = now.getMonth() + 1
    const lastDayOfTargetMonth = new Date(now.getFullYear(), targetMonth + 1, 0).getDate()
    presets.push({
        id: "one-month",
        label: "In a month",
        at: new Date(now.getFullYear(), targetMonth, Math.min(now.getDate(), lastDayOfTargetMonth), 9, 0, 0, 0),
    })
    return presets
}

export function toLocalSnoozeInputValue(at: Date): string {
    const year = String(at.getFullYear()).padStart(4, "0")
    const month = String(at.getMonth() + 1).padStart(2, "0")
    const day = String(at.getDate()).padStart(2, "0")
    const hour = String(at.getHours()).padStart(2, "0")
    const minute = String(at.getMinutes()).padStart(2, "0")
    return `${year}-${month}-${day}T${hour}:${minute}`
}

export function parseLocalSnoozeTime(value: string): Date | null {
    const at = new Date(value)
    return Number.isNaN(at.getTime()) ? null : at
}
